module.exports = "input.ng-dirty.ng-invalid {\n  color: red; }\n\n.text-left {\n  overflow: hidden;\n  margin-bottom: 10px; }\n\n.regentry {\n  margin-bottom: 10px;\n  border: 1px solid #eeeeee;\n  padding: 20px; }\n\n.manage-item-list {\n  clear: both; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/item-create/item-create.component.scss
// module id = ./src/app/pages/item-create/item-create.component.scss
// module chunks = main